// ShadowContext.js
import { createContext } from 'react';

const ShadowContext = createContext();

export default ShadowContext;
